/* eslint-disable @next/next/no-img-element */
import Link from 'next/link';
import {  urlFor } from '../lib/sanity'
import imagePanelStyles from '../styles/LeadingImagePanelGen.module.scss';


function LeadingImagePanel({ HeaderImage, headerWidth = '1920', headerHeight = '680', headerMinHeight = '300' }) {
  return (
    <div className={imagePanelStyles.imageHolder}>
      <picture>
        <source media="(min-width:768px)" srcSet={urlFor(HeaderImage.headerimage).width(`${headerWidth}`).height(`${headerHeight}`).url()} />
        <img src={urlFor(HeaderImage.headerimage).auto('format').width(450).height(400).fit('crop').url()} alt={HeaderImage?.headerimage?.alt} className={imagePanelStyles.leadingImage} width={`${headerWidth}`} height={`${headerHeight}`} style={{ minHeight: `${headerMinHeight}px` }} />
      </picture>

      {/* <div className={imagePanelStyles.container}>
        <div className={imagePanelStyles.contentPanel} style={{ backgroundImage: 'url(/images/static/content-panel-back-light-blue.png)' }}>

          <h2>An award winning childcare provider with two nurseries in Greenwich and South East London</h2>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis.
          </p>

           <Link href="/maps/">
            <button className={imagePanelStyles.telTo}>View Map Locations</button>
          </Link>
           <Link href="/about-us/">
            <button className={imagePanelStyles.telTo}>About Us</button>
          </Link>

        </div>
      </div> */}
    </div>
  );
}



export default LeadingImagePanel;
